<mpro-loading *ngIf="loadingCitiySpendingAndDistribution || (dataService.getIsLoading() | async)"></mpro-loading>
<div class="row">
  <div class="col-9">
    <span *ngIf="isCategories && !isFreemium" class="header">{{getNameValuePair(categoriesList, dataFilters.category).name}} Demand</span>
    <span *ngIf="!isCategories && !isFreemium" class="header">{{this.dataFilters.spendingGroup.type}} Distribution</span>
    <span *ngIf="isFreemium" class="header">Future Demand Distribution</span>
    <p class="sub-header">{{ dataFilters.regionSelection.getName() }} - {{ dataFilters.year }}</p>
    <mpro-tags style="margin: 14px 0px;" [spending]="false"></mpro-tags>
    <!-- tags -->
  </div>
</div>

<mpro-horziontal-bar-chart [data]="chartData" [options]="chartOptions"></mpro-horziontal-bar-chart>

<mpro-spending-distrib-breakdown-table
  style="margin-top: 14px;"
  [sdData]="spendingData" [selected]="spendingSelected" [total]="total" [inTrillion]="!!dataFilters.spendingPer">
</mpro-spending-distrib-breakdown-table>
